<template>
	<DjBox class="pt-5 md:pt-8 px-5 md:px-10 pb-5 md:pb-10">
		<h3 class="text-lg md:text-xl font-medium mb-4">{{ title }}</h3>
		<div class="">
			<div v-if="langs && salary && !salary.notSpecified && salary.salary" class="flex flex-col">
				<span class="text-sm text-dj-gray mb-1">
					{{ langs.amountIn }}
					<template v-if="salary.salaryPeriod === 'hour' && langs.perHour">
						{{ langs.perHour }}
					</template>
					<template v-else-if="salary.salaryPeriod === 'month' && langs.perMonth">
						{{ langs.perMonth }}
					</template>
					<template v-else-if="langs.salaryRange && langs.salary">
						{{ salary.salary!.includes("-") ? langs.salaryRange : langs.salary }}
					</template>
				</span>
				<span v-if="salary.currency">{{ salary.salary }} {{ salary.currency.toLocaleUpperCase() }}</span>
				<span v-if="salary?.other?.[locale]?.length > 0">{{ salary.other[locale] ?? "" }}</span>
			</div>
			<div v-else class="flex flex-col">
				<span v-if="title" class="text-sm text-dj-gray mb-1">{{ title }}</span>
				<span v-if="langs">{{ langs.notSpecified }}</span>
			</div>
		</div>
		<div v-if="salary && salary.bonus?.[locale]?.length > 0" class="flex flex-col mt-4">
			<span v-if="langs && langs.bonus" class="text-sm text-dj-gray mb-1">+{{ langs.bonus }}</span>
			<div class="list-style" v-html="salary.bonus[locale]"></div>
		</div>
	</DjBox>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { useI18n } from "vue-i18n";

type salaryType = {
	notSpecified: boolean;
	currency?: string;
	amountIn?: string;
	salaryPeriod?: string;
	salary?: string;
	other?: string;
	bonus?: string;
};

type salaryLangs = {
	notSpecified: string;
	salaryRange: string;
	salary: string;
	bonus: string;
	amountIn: string;
	perMonth?: string;
	perHour?: string;
};

export default defineComponent({
	name: "DjBoxSalary",
	props: {
		title: {
			type: String,
			default: "Default title",
		},
		salary: {
			type: Object as PropType<salaryType>,
			required: false,
		},
		langs: {
			type: Object as PropType<salaryLangs>,
			required: false,
		},
	},
	setup() {
		const { locale } = useI18n();

		return {
			locale,
		};
	},
});
</script>

<style>
.list-style ul,
ol {
	padding-left: 1.2rem;
}

.list-style ul li {
	list-style-type: disc;
}
.list-style ol li {
	list-style-type: decimal;
}
</style>
